import React from "react";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { NAV_LINKS, TREATMENTS, LOGO_URL } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#0f2a1c] text-white/85 pt-20 pb-10">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <div className="inline-flex items-center">
              <img
                src={LOGO_URL}
                alt="Tatva Wellness Center"
                className="h-28 w-auto object-contain bg-[#fbf9f4] rounded-xl p-3 shadow-lg"
              />
            </div>
            <p className="mt-6 text-sm leading-relaxed text-white/60">
              Naturopathic care that reconnects you to your body&apos;s innate
              intelligence — for deep, lasting wellness.
            </p>
            <div className="flex gap-3 mt-6">
              {[Instagram, Facebook, Youtube].map((Ic, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#c4a257] hover:text-[#0f2a1c] hover:border-[#c4a257] transition-all"
                >
                  <Ic className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-white/60 hover:text-[#c4a257] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-5">Treatments</h4>
            <ul className="grid grid-cols-1 gap-2.5 text-sm">
              {TREATMENTS.slice(0, 6).map((t) => (
                <li key={t.title} className="text-white/60 hover:text-[#c4a257] transition-colors cursor-pointer">
                  {t.title}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-5">Contact</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=3HXF%2BV2+Bengaluru+Karnataka"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#c4a257] transition-colors"
                >
                  MANASA — 61'B, SFS 208 Colony,<br />
                  Yelahanka New Town,<br />
                  Bengaluru, Karnataka 560064
                </a>
              </li>
              <li>
                <a href="tel:+919845342025" className="hover:text-[#c4a257] transition-colors">
                  +91 98453 42025
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/919845342025"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#c4a257] transition-colors"
                >
                  WhatsApp: +91 98453 42025
                </a>
              </li>
              <li className="break-all">
                <a
                  href="mailto:admin@tatvawellnesscenter.in"
                  className="hover:text-[#c4a257] transition-colors"
                >
                  admin@tatvawellnesscenter.in
                </a>
              </li>
              <li className="pt-2 text-xs uppercase tracking-[0.2em] text-[#c4a257]">
                Mon – Sat · 8:00 – 19:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Tatva Wellness Center. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            Reconnect · Rebalance · Rediscover You
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
